/* template */
<template><div class="banner-container" v-if="(banner)"><mpx-swiper :indicator-dots="(!onlyOne)" indicator-active-color="#fff" indicator-color="rgba(255, 255, 255, 0.3)" :scroll-options="(swiperOption)" circular :autoplay="(!onlyOne)" :interval="(2000)" @change="handleSwiperChange" class="swiper-container"><mpx-swiper-item v-for="(item, index) in (banner)" :key="item.image"><mpx-image :src="(item.image)" @tap="click(item)" class="image"/></mpx-swiper-item></mpx-swiper></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mcf025d98"}'>
.banner-container
  margin 40rpx auto 0
  width: 710rpx;
  height 200rpx
  overflow hidden
  transform rotate(0deg)
  .swiper-container
    width 100%
    height 100%
    overflow hidden
    position relative
    border-radius 28rpx
    transform rotate(0deg)
    .image
      height 200rpx
      width 710rpx
</style>
<style lang="stylus" mpxStyleOptions='{"mid":"mcf025d98"}'>
.mpx-swiper
  overflow hidden
  position relative
.mpx-swiper-content
  width 100%
  height 100%
  display flex
  .mpx-swiper-item
    width 100%
    height 100%
    flex 1 0 auto
.mpx-swiper-dots
  position absolute
  right 50%
  bottom 25rpx
  // NOTE 为什么要使用translateZ
  // swiper-content拥有一个translateZ，这导致其会覆盖在指示器上方，导致指示器被隐藏
  transform translateX(50%) translateZ(11px)
  display flex
  .mpx-swiper-dots-item
    display block
    margin 4rpx
    width 8rpx
    height 8rpx
    border-radius 50%
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mcf025d98"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./res-banner.mpx.js?isComponent&outputPath=components%2Fres-bannercf025d98%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./res-banner.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fres-bannercf025d98%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mcf025d98"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/res-bannercf025d98/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-swiper':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-swiper.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-swiper-item':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-swiper-item.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
